module.exports = __webpack_public_path__ + "img/趣味滤镜.c1cb3855.png";